'use client';

import { Box } from '@wishket/design-system';
import { use } from 'react';

import LandingArticleItem from '../LandingArticle/LandingArticleItem';

import { LandingArticleItemProps } from '@/shared/types';

interface TrendingContentsProps {
  contentsPromise: Promise<LandingArticleItemProps[]>;
}

const TrendingContents = ({ contentsPromise }: TrendingContentsProps) => {
  const mainContent = use(contentsPromise);

  return (
    <Box
      className="grid grid-cols-1 gap-6 tablet:grid-cols-2 tablet:gap-5 desktop:grid-cols-1 desktop:gap-10"
      data-testid="landing-trending-contents-list"
    >
      {mainContent.map((content) => (
        <LandingArticleItem {...content} key={content.articleInfo.id} />
      ))}
    </Box>
  );
};

export default TrendingContents;
